var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDevicePrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.75H4V3.5C4 1.56953 5.56953 0 7.5 0H20.0508C20.9805 0 21.8719 0.366406 22.5281 1.02266L23.9773 2.47187C24.6336 3.12812 25 4.01953 25 4.94922V8.75H23.25V4.94922C23.25 4.48438 23.0641 4.04141 22.7359 3.71328L21.2867 2.26406C20.9586 1.93594 20.5156 1.75 20.0508 1.75H7.5C6.53203 1.75 5.75 2.53203 5.75 3.5V8.75ZM25 12.25H4C3.03203 12.25 2.25 13.032 2.25 14V21H4V19.25C4 18.282 4.78203 17.5 5.75 17.5H23.25C24.218 17.5 25 18.282 25 19.25V21H26.75V14C26.75 13.032 25.968 12.25 25 12.25ZM25 22.75V26.25C25 27.218 24.218 28 23.25 28H5.75C4.78203 28 4 27.218 4 26.25V22.75H2.25C1.28203 22.75 0.5 21.968 0.5 21V14C0.5 12.0695 2.06953 10.5 4 10.5H25C26.9305 10.5 28.5 12.0695 28.5 14V21C28.5 21.968 27.718 22.75 26.75 22.75H25ZM5.75 19.25V26.25H23.25V19.25H5.75ZM24.125 13.5625C24.4731 13.5625 24.8069 13.7008 25.0531 13.9469C25.2992 14.1931 25.4375 14.5269 25.4375 14.875C25.4375 15.2231 25.2992 15.5569 25.0531 15.8031C24.8069 16.0492 24.4731 16.1875 24.125 16.1875C23.7769 16.1875 23.4431 16.0492 23.1969 15.8031C22.9508 15.5569 22.8125 15.2231 22.8125 14.875C22.8125 14.5269 22.9508 14.1931 23.1969 13.9469C23.4431 13.7008 23.7769 13.5625 24.125 13.5625Z",
    fill: "#302B29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDevicePrinterIcon);
export default __webpack_public_path__ + "static/media/addDevice-printerIcon.a785aa05b55b670b6c623f1919ea2bfd.svg";
export { ForwardRef as ReactComponent };